<template>
  <BaseCard
    :heading="t('global.settings')"
    v-test="'website-service-giftcard-widget-card'"
  >
    <Flex
      direction="column"
      :gap="1"
    >
      <BaseToggle
        v-model="giftcardWidgetEnabled"
        :disabled="
          (!giftcardWidgetEnabled && !canEnableGiftcardWidget) ||
          loading
        "
        :label="t('website_service.dashboard.giftcard_widget.toggle')"
        v-test="'website-service-giftcard-widget-toggle'"
      />
      <EnablePayment
        v-model="canEnableGiftcardWidget"
        :description="t('website_service.dashboard.giftcard_widget.payment_required')"
      />
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { computed, inject, type Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash } from '@/helpers/ui';
import EnablePayment from '@/modules/admin/_shared/EnablePayment.vue';
import type { Website } from '@/types';
import { UPDATE_WEBSITE } from '../../graphql';

const { t } = useI18n();

const website = inject<Ref<Website | null>>('website');
const canEnableGiftcardWidget = ref(false);

const { mutate, loading } = useMutation(UPDATE_WEBSITE);

const giftcardWidgetEnabled = computed({
  get: () => website?.value?.giftcardWidgetEnabled ?? false,
  set: (enabled: boolean) => updateGiftcardWidgetEnabled(enabled),
});

function updateGiftcardWidgetEnabled(enabled: boolean) {
  if (!website?.value || loading.value) return;

  const previousValue = website.value.giftcardWidgetEnabled ?? false;
  website.value.giftcardWidgetEnabled = enabled;

  mutate({
    input: { giftcardWidgetEnabled: enabled },
  })
    .then((result) => {
      const updatedWebsite = result?.data?.updateWebsite?.website;
      if (updatedWebsite) {
        website.value!.giftcardWidgetEnabled =
          updatedWebsite.giftcardWidgetEnabled;
        flash(t('global.flash.settings_saved'));
      } else {
        website.value!.giftcardWidgetEnabled = previousValue;
      }
    })
    .catch(() => {
      website.value!.giftcardWidgetEnabled = previousValue;
    });
}
</script>
